import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { 
  findProductById, 
      getProductImage, 
  getProductCsvLookupId 
} from '../../utils/productHelpers';

const GarminGpsmap8610xsv = () => {
  console.log('🎯 GarminGpsmap8610xsv component loading');
  
  const product = findProductById("gpsmap-8610xsv");
  
  if (!product) {
    console.error('Product not found:', "gpsmap-8610xsv");
    return <div>Product not found</div>;
  }
  
  return (
    <SimpleProductPage 
      specificProductId="gpsmap-8610xsv"
      productName={product.name}
      productImage={getProductImage(product)}
      csvLookupId={getProductCsvLookupId(product)}
      csvExactMatchOnly={true}
    />
  );
};

export default GarminGpsmap8610xsv; 